/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `WAITING_FOR_PROCESSING` - Waiting for processing
 *   * `PROCESSING` - Processing
 *   * `FAILED` - Failed
 *   * `PROCESSED` - Processed
 * ```
 */
export const HarvestStatesEnum = {
  WAITING_FOR_PROCESSING: 'WAITING_FOR_PROCESSING',
  PROCESSING: 'PROCESSING',
  FAILED: 'FAILED',
  PROCESSED: 'PROCESSED',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type HarvestStatesEnum = ValuesOf<typeof HarvestStatesEnum>;

export type HarvestStatesEnumRequest = HarvestStatesEnum;
export type HarvestStatesEnumResponse = HarvestStatesEnum;
